'use client';
import { useState, FormEvent } from 'react';
import { useRouter } from 'next/navigation';
import Link from 'next/link';
import { useT } from '@/lib/i18n';

export default function RegisterPage() {
  const t = useT();
  const router = useRouter();
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  async function handleSubmit(e: FormEvent) {
    e.preventDefault();
    setError('');
    const res = await fetch('/api/auth/register', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ name, email, password }),
    });
    if (!res.ok) {
      const data = await res.json();
      setError(data.error ?? 'Registration failed');
      return;
    }
    router.push('/login');
  }

  return (
    <div className="min-h-full flex items-center justify-center px-4 py-16">
      <div className="w-full max-w-sm">
        <h1 className="text-2xl font-bold mb-8 text-center">{t('auth.register')}</h1>
        <form onSubmit={handleSubmit} className="flex flex-col gap-4">
          <div className="flex flex-col gap-1">
            <label className="text-sm text-slate-500">{t('auth.name')}</label>
            <input
              type="text"
              value={name}
              onChange={e => setName(e.target.value)}
              className="bg-sky-100 border border-sky-300 rounded-lg px-3 py-2 text-slate-900 focus:outline-none focus:border-violet-500"
            />
          </div>
          <div className="flex flex-col gap-1">
            <label className="text-sm text-slate-500">{t('auth.email')}</label>
            <input
              type="email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              required
              className="bg-sky-100 border border-sky-300 rounded-lg px-3 py-2 text-slate-900 focus:outline-none focus:border-violet-500"
            />
          </div>
          <div className="flex flex-col gap-1">
            <label className="text-sm text-slate-500">{t('auth.password')}</label>
            <input
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              required
              className="bg-sky-100 border border-sky-300 rounded-lg px-3 py-2 text-slate-900 focus:outline-none focus:border-violet-500"
            />
          </div>
          {error && <p className="text-red-400 text-sm">{error}</p>}
          <button
            type="submit"
            className="bg-violet-600 hover:bg-violet-500 text-white rounded-lg px-4 py-2 font-medium transition-colors"
          >
            {t('auth.register')}
          </button>
        </form>
        <p className="mt-6 text-center text-sm text-slate-500">
          {t('auth.hasAccount')}{' '}
          <Link href="/login" className="text-violet-400 hover:text-violet-300">
            {t('auth.login')}
          </Link>
        </p>
      </div>
    </div>
  );
}
